 document.querySelectorAll('.toggleButton').forEach((button, index) => {
    const content = document.querySelectorAll('.content-tabs')[index];

    button.addEventListener('click', () => {
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        button.textContent = 'MORE';
      } else {
            document.querySelectorAll('.toggleButton').forEach((button1, index1) => {
               if (index === index1) {
                  content.style.maxHeight = content.scrollHeight + 'px';
                  button.textContent = 'MORE';
               } else {
                 const content1 = document.querySelectorAll('.content-tabs')[index1];
                  content1.style.maxHeight = null;
                  button1.textContent = 'MORE';
               }
             
          });
       
      }
    });
  });